import type {
  ApiSuccess,
  CustomerOrderDetail,
  CustomerOrderList,
  PlaceOrderInput,
  Quote,
  QuoteInput,
} from '@capsico/contracts';
import { HEADERS } from '@capsico/contracts';
import { api } from './client';

/**
 * Checkout API (W10). The quote is a read with a body (the cart): the server prices it every
 * time, so the app never decides a price. Placing an order sends one idempotency key per
 * attempt — a retry after a dropped connection returns the same order, never a second one.
 */
export async function fetchQuote(input: QuoteInput): Promise<Quote> {
  const res = await api.post<ApiSuccess<Quote>>('/v1/checkout/quote', input);
  return res.data.data;
}

export async function placeOrder(
  input: PlaceOrderInput,
  idempotencyKey: string,
): Promise<CustomerOrderDetail> {
  const res = await api.post<ApiSuccess<CustomerOrderDetail>>('/v1/checkout/me/orders', input, {
    headers: { [HEADERS.IDEMPOTENCY_KEY]: idempotencyKey },
  });
  return res.data.data;
}

export async function fetchMyOrders(): Promise<CustomerOrderList> {
  const res = await api.get<ApiSuccess<CustomerOrderList>>('/v1/checkout/me/orders');
  return res.data.data;
}

export async function fetchMyOrder(orderId: string): Promise<CustomerOrderDetail> {
  const res = await api.get<ApiSuccess<CustomerOrderDetail>>(`/v1/checkout/me/orders/${orderId}`);
  return res.data.data;
}
